import * as React from "react";
import AuthService from "./Service/AuthService";
import FirebaseService from './Service/FirebaseService';
// -- Import only the relevant firebase packages or it complains at you.
import * as firebase from 'firebase/app';
import 'firebase/auth';


import "./App.css";

import Message from "./Models/Message/Message";

import AppAlert from "./Components/AppAlert/AppAlert";
import InputBar from "./Components/InputBar/InputBar";
import MessageContainer from "./Components/MessageContainer/MessageContainer";
import User from "./Models/User/User";
import Tabs from "./Components/Tabs/Tabs";
import UserList from "./Components/UserList/UserList";

export interface IAppParams {
    user: string;
    userlinkname: string;
    room: string;
    endpoint: string;
    fbAuthToken: string;
}

export interface IAppState {
    messages: Message[];
    users: User[];
    user: User;
    room: string;
    endpoint: string;
    appState: APP_STATES;
    fbAuthToken: string;
}

enum APP_STATES {
    LOADING,
    AUTHORIZED,
    UNAUTHORIZED,
    ERROR
}

export class App extends React.Component<IAppParams, IAppState> {
    public state: IAppState = {
        room: this.props.room,
        user: new User(this.props.user, 'online', this.props.userlinkname),
        endpoint: this.props.endpoint,
        messages: [],
        users: [],
        appState: APP_STATES.LOADING,
        fbAuthToken: this.props.fbAuthToken
    };

    componentDidMount() {
        FirebaseService.init(this.state.room, this.state.user);
        this.checkAuthorization();
    }

    // This executes after the auth process in checkAuthorization() completes.
    postAuthSetup() {
        this.setupFirebaseListeners();
        this.enableLeavePage();
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handleLeavePage);
    }

    enableLeavePage():void {
        window.addEventListener('beforeunload', this.handleLeavePage);
    }

    handleLeavePage():void {
        FirebaseService.setupLeaveListeners();
    }

    setupFirebaseListeners() {


        FirebaseService.setupFirebaseSync((snapshot) => {
            const val = snapshot.val();
            //console.log("room snapshot: ", snapshot.val());

            if (val.messages) {
                const messages: Message[] = [];

                Object.keys(val.messages).forEach((key) => {
                    messages.push(
                        new Message(
                            val.messages[key].content,
                            val.messages[key].user,
                            val.messages[key].userLinkName,
                            val.messages[key].timestamp,
                            val.messages[key].room
                        )
                    );
                });

                this.setState({
                    messages
                })
            }

            if (val.users) {
                const users: User[] = [];

                Object.keys(val.users as User[]).forEach((key) => {
                    users.push(
                        new User(
                            key,
                            val.users[key].status,
                            val.users[key].userLinkName
                        )
                    );
                });

                this.setState({
                    users
                })
            }
        })

        FirebaseService.setupUserListeners((userList: User[]) => {
            this.setState({
                users: userList
            })
        });
    }

    // NOTE: This runs early in setup; need to auth before we establish connections.
    checkAuthorization() {
        // Check with AuthService to see if name/room is valid
        AuthService.checkAuthorization(this.state.fbAuthToken)
            .then( (authorizedUserCredential: firebase.auth.UserCredential) => {
                console.log("this is authorized");
                this.setState({
                    appState: APP_STATES.AUTHORIZED
                });
                // Continue with the setup steps after authentication
                this.postAuthSetup();
            }).catch(function(error) {
                // Handle Errors here.
                console.warn("NOT authorized");
                this.setState({
                    appState: APP_STATES.UNAUTHORIZED
                });
        });
    }

    render() {
        const renderFromState: (
            appState: APP_STATES
        ) => JSX.Element | JSX.Element[] = appState => {
            switch (appState) {
                case APP_STATES.LOADING:
                    return (
                        <AppAlert className="loading" message="Loading..." />
                    );
                    break;

                case APP_STATES.UNAUTHORIZED:
                    return (
                        <AppAlert
                            className="error"
                            message="You are not authorized to view this chatroom"
                        />
                    );
                    break;

                case APP_STATES.ERROR:
                    return (
                        <AppAlert
                            className="error"
                            message="An error has occured"
                        />
                    );
                    break;

                case APP_STATES.AUTHORIZED:
                    return (
                        <Tabs
                            chat={
                                <>
                                    <MessageContainer
                                        key="MessageContainer"
                                        messages={this.state.messages}
                                    />
                                    <InputBar key="InputBar" />
                                </>
                            }
                            userList={<UserList users={this.state.users} />}
                        />
                    );
                    break;
            }
        };

        return (
            <div className="cca-etl-chat-app">
                {renderFromState(this.state.appState)}
            </div>
        );
    }
}
